import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAccessToken } from '../../../services/authService';
import { setConnectionErrorOpen } from '../../../store/navSlice';
import { useDispatch } from 'react-redux';
import LoaderSpin from '../../Common/LoaderSpin';

// Creates an empty Commercial document (no title-page form) immediately (no title-page form) and opens the editor.
const Commercial = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const startedRef = useRef(false)

    useEffect(() => {
        if (startedRef.current) return
        startedRef.current = true

        const createScript = async () => {
            const token = getAccessToken()
            const url = `${process.env.REACT_APP_DEV_API}/document`;
            try {
                if (!token) {
                    throw new Error('A valid session not found')
                }
                const res = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({ type: 'COMMERCIAL', content: '<p></p>', status: 'INCOMPLETE' })
                })
                const body = await res.json()
                if (!res.ok) {
                    console.error(res);
                    throw new Error(body.message ? body.message : 'Error getting response')
                }
                // Always open the editor (desktop and mobile)
                navigate(`/editor/${body.data._id}`)
            } catch (error) {
                if (error.message === 'Failed to fetch' || error.name === 'TypeError') {
                    dispatch(setConnectionErrorOpen(true))
                }
                toast.error(error.message)
                console.error(error)
                navigate('/home')
            }
        }

        createScript()
    }, [dispatch, navigate])

    return (
        <div className='overflow-y-hidden h-full flex flex-col items-center justify-center gap-4'>
            <LoaderSpin />
            <p className='text-[#868686] text-14 font-bold'>Creating your commercial...</p>
        </div>
    );
};

export default Commercial;
